import { Typography } from 'antd'
import styled, { css } from 'styled-components'
import { color, fontSize, padding } from 'theme/mixins'

const GroupLabel = styled(Typography.Text)<{ $required?: boolean }>`
	display: flex;
	padding-bottom: ${padding('xs')};

	${({ $required }) =>
		$required &&
		css`
			:before {
				content: '*';
				padding-right: ${padding('xxs')};
				font-size: ${fontSize('sm')};
				color: ${color(['error', '400'])};
			}
		`}
`

export default { GroupLabel }
